import React from "react";

import AiCard from "lib/core_components/AiCard";
import StatisticsCard from "lib/core_components/StatisticsCard";
import { useCompetitorPartnerInfoOnBuyer } from "lib/hooks/api/organisations/useCompetitorPartnerInfoOnBuyer";
import { useBuyerStats } from "lib/hooks/api/organisations/useOrganisationStats";
import { BuyerDetails } from "lib/types/models";
import { QuestionPanel } from "./question_panel/QuestionPanel";

import css from "./HeaderStatisticCards.module.scss";

type HSCProps = {
  onHeaderChange: ({ trackingType, route }: { trackingType: string; route: string }) => void;
  buyer: BuyerDetails;
  currentTabPath: string;
};

function HeaderStatisticCards({ onHeaderChange, buyer, currentTabPath }: HSCProps): JSX.Element {
  const { data: buyerStats, isLoading: isLoadingBuyerStats } = useBuyerStats(buyer.guid);
  const [isAiModalOpen, setIsAiModalOpen] = React.useState(false);

  const {
    competitorCount,
    partnerCount,
    isLoading: isLoadingBuyerSupplierCounts,
  } = useCompetitorPartnerInfoOnBuyer(buyer.guid);

  return (
    <div className={css.container}>
      <QuestionPanel
        resourceId={buyer.guid}
        resourceName={buyer.name}
        isOpen={isAiModalOpen}
        onClose={() => setIsAiModalOpen(false)}
      />

      <AiCard
        title="Ask a question about this buyer"
        onClick={() => {
          setIsAiModalOpen(true);
        }}
      />

      <StatisticsCard
        value={buyerStats?.allNoticesCount ?? 0}
        loading={isLoadingBuyerStats}
        objectType="Notice"
        description="Matching my signals"
        onClick={() =>
          onHeaderChange({
            route: "/activity/all",
            trackingType: "Records matching keywords",
          })
        }
        active={currentTabPath === "/activity/all"}
      />
      <StatisticsCard
        value={buyerStats?.upcomingExpiriesCount ?? 0}
        loading={isLoadingBuyerStats}
        objectType="Upcoming expiry"
        pluralObjectType="Upcoming expiries"
        description="Matching my signals"
        onClick={() =>
          onHeaderChange({
            route: "/activity/upcoming_expiries",
            trackingType: "Upcoming expiries matching keywords",
          })
        }
        active={currentTabPath === "/activity/upcoming_expiries"}
      />
      <StatisticsCard
        value={buyerStats?.openOpportunitiesCount ?? 0}
        loading={isLoadingBuyerStats}
        objectType="Open opportunity"
        pluralObjectType="Open opportunities"
        description="Matching my signals"
        onClick={() =>
          onHeaderChange({
            route: "/activity/open_opportunities",
            trackingType: "Open opportunities matching keywords",
          })
        }
        active={currentTabPath === "/activity/open_opportunities"}
      />
      <StatisticsCard
        value={partnerCount}
        loading={isLoadingBuyerSupplierCounts}
        objectType="Partner"
        description="Connected to buyer"
        onClick={() =>
          onHeaderChange({
            route: "/suppliers/partners",
            trackingType: "Partners connected to this buyer",
          })
        }
        active={currentTabPath === "/suppliers/partners"}
      />
      <StatisticsCard
        value={competitorCount}
        loading={isLoadingBuyerSupplierCounts}
        objectType="Competitor"
        description="Connected to buyer"
        onClick={() =>
          onHeaderChange({
            route: "/suppliers/competitors",
            trackingType: "Competitors connected to this buyer",
          })
        }
        active={currentTabPath === "/suppliers/competitors"}
      />
    </div>
  );
}

export default HeaderStatisticCards;
